export enum SessionStorage {
  FOLLOW_COLLEGE_ID = 'followCollegeId',
}
